import { Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';
import { ConditionalRender } from '@ui';
import { IoClose } from 'react-icons/io5';
import { DiscardConfirmationRecord, OutcomeData, TurndownRecord } from '@/api/apis/case';
import SectionRow from '../SectionRow';
import { SignatureRow } from './SignatureRow';
import { OutcomeFields } from './OutcomeFields';

type OutcomeModalProps = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  header: string;
  discardDescription: string;
  discardConfirmationFormData?: DiscardConfirmationRecord;
  outcomeData?: OutcomeData;
  oneLungTurndown?: TurndownRecord;
};

export const OutcomeModal = ({
  isOpen,
  onOpen,
  onClose,
  header,
  discardDescription,
  discardConfirmationFormData,
  outcomeData,
  oneLungTurndown,
}: OutcomeModalProps) => {
  const { nurse, ocsSpecialist } = discardConfirmationFormData?.item ?? {};

  return (
    <Modal
      className="scroll"
      scrollBehavior="outside"
      isOpen={isOpen}
      onOpenChange={onOpen}
      onClose={onClose}
      size="3xl"
      closeButton={<IoClose size={42} className="z-1000" />}
      classNames={{
        closeButton: 'text-base-10 mt-6 mr-4',
        header: 'text-hl! flex flex-col gap-4 text-base-20 pt-6 pb-4',
        body: 'flex flex-col mx-6 p-0 pb-6 gap-6',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <div>
            <div className="font-secondary">{header}</div>
            <div className="text-m-r">{discardDescription}</div>
          </div>
          <Divider />
        </ModalHeader>
        <ModalBody>
          <OutcomeFields outcomeData={outcomeData} oneLungTurndown={oneLungTurndown} />
          <ConditionalRender show={!!discardConfirmationFormData}>
            <SectionRow label="Nurse Signature">
              <div className="flex justify-between">
                <span>{nurse?.signature.fullName}</span>
                <SignatureRow
                  filePath={nurse?.signature?.file.path}
                  timestamp={nurse?.timestamp}
                  timeZone={nurse?.timeZone}
                  hideTimestamp
                />
              </div>
            </SectionRow>
            <SectionRow label="OCS Specialist Signature">
              <div className="flex justify-between">
                <span>{ocsSpecialist?.signature.fullName}</span>
                <SignatureRow
                  filePath={ocsSpecialist?.signature?.file.path}
                  timestamp={ocsSpecialist?.timestamp}
                  timeZone={ocsSpecialist?.timeZone}
                  hideTimestamp
                />
              </div>
            </SectionRow>
          </ConditionalRender>
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
